import PropTypes from 'prop-types';

export const PaginationType = PropTypes.shape({
  next: PropTypes.number,
  prev: PropTypes.number,
  count: PropTypes.number,
  page: PropTypes.number.isRequired,
  limit: PropTypes.number
}).isRequired;

export const QueryType = PropTypes.shape({
  $search: PropTypes.string.isRequired,
  stringify: PropTypes.func.isRequired,
  overwrite: PropTypes.func.isRequired,
}).isRequired;

export const RouterTypes = {
  match: PropTypes.shape({
    isExact: PropTypes.bool.isRequired,
    params: PropTypes.object.isRequired,
    path: PropTypes.string.isRequired,
    url: PropTypes.string.isRequired,
  }).isRequired,
  location: PropTypes.shape({
    hash: PropTypes.string.isRequired,
    key: PropTypes.string.isRequired,
    search: PropTypes.string.isRequired,
    pathname: PropTypes.string.isRequired,
    state: PropTypes.object
  }).isRequired,
};


// WEBPACK FOOTER //
// ./src/GLOBAL_TYPES.js